import Dto from "../../../../../lib/model/service/Dto";

class IsAnalyticsActivated extends Dto {

  campaignId;

  constructor(campaignId = '') {
    super('appl\\service\\campaign\\dto\\IsAnalyticsActivated');
    this.campaignId = campaignId;
  }

  getCampaignId() {
    return this.campaignId;
  }

  setCampaignId(campaignId) {
    this.campaignId = campaignId;
  }

}

export default IsAnalyticsActivated;
